<template>
  <div class="adp-modal-row adp-modal-competence-block-inputs">
    <div>
      <div class="d-flex justify-content-between align-items-baseline">
        <label class="adp-p adp-p__grey">{{ $t('catalog.competence') }}</label>
        <button class="btn adp-btn-outline float-right" v-if="hasDeleteButton" @click="clearCompetence">
          {{ $t('catalog.clear_competence') }}
        </button>
      </div>
      <v-select :options="options" label="name" v-model="competence"
                :placeholder="$t('catalog.choose_competence')" :filterable="true" :clearable="false"
                @input="option => selectCompetence()">
        <template #option="option">
          <span class="adp-p adp-p__grey"
                style="max-width: 100%; white-space: pre-line">{{ option.categories.join(' • ') }}</span>
          <br>
          <span class="adp-p">{{ option.name }}</span>
        </template>
        <template #no-options="{ search, searching }">
          <template v-if="searching">
            {{ $t('catalog.no_result_name') }} <em>{{ search }}</em>.
          </template>
          <span class="adp-p adp-p__grey" v-else>{{ $t('catalog.start_typing_for_search') }}</span>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import api from '../api';
import _ from 'lodash';

export default {
  name: "CompetenceSkillsBlock",
  props: {
    competenceObj: {
      type: Object,
      default: function () {
        return {id: null, name: null, skills: [null]};
      },
    },
    hasDeleteButton: {
      type: Boolean,
      default: false,
    },
    competenceOptions: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    options() {
      if (this.competenceOptions.length > 0) {
        return this.competenceOptions
      } else {
        return this.defaultCompetenceOptions;
      }
    }
  },
  data: function () {
    return {
      competence: this.competenceObj,
      defaultCompetenceOptions: [],
    }
  },
  watch: {
    competenceObj(newVal) {
      this.competence = newVal;
    },
  },
  methods: {
    clearCompetence() {
      this.$emit('delete-competence');
    },
    async fetchCompetences() {
      try {
        this.defaultCompetenceOptions = await api.searchCompetences('');
      } catch (e) {
        console.log(e);
      }
    },
    async selectCompetence() {
      this.$emit('select-competence', {id: this.competence.id, name: this.competence.name,});
    },
  },

  mounted() {
    this.fetchCompetences();
  }

}
</script>
